export default "__VITE_ASSET__CUXhFwm1__"